import React, { useState } from 'react';
import { useAiAttention } from '../hooks/useAi';
import { openCompare } from '../utils/compareLink';
import { formatEventDateOnly, timeAgo } from '../utils/dates';

// "Needs attention" panel at the top of the Dashboard: the top events by AI
// attention score for the caller's scope, each deep-linking to Compare.
// Renders nothing when the assistant is off, errored, loading, or empty.
function AttentionPanel() {
  const { data, isError } = useAiAttention();
  const [open, setOpen] = useState(true);
  const [showAll, setShowAll] = useState(false);

  if (isError || !data?.enabled || !data.flags?.length) return null;

  const rows = showAll ? data.flags : data.flags.slice(0, 10);

  return (
    <div className="attention-panel">
      <div className="attention-header" onClick={() => setOpen(o => !o)}>
        <span className="sales-toggle">{open ? '▼' : '▶'}</span>
        <span>Needs attention</span>
        <span className="attention-count">{data.total} event{data.total === 1 ? '' : 's'} flagged by the AI assistant</span>
      </div>
      {open && (
        <div className="attention-list">
          {rows.map(f => (
            <div key={f.eventId} className="attention-row">
              <span className={`priority-chip ${f.priorityScore >= 80 ? 'p-high' : f.priorityScore >= 50 ? 'p-med' : ''}`} title="Attention score (0–100)">
                {Math.round(f.priorityScore || 0)}
              </span>
              <div className="attention-main">
                <div className="attention-title">
                  {f.performer && f.performer !== f.eventName ? `${f.performer} — ` : ''}{f.eventName}
                </div>
                <div className="attention-sub">
                  {formatEventDateOnly(f.eventDate, { weekday: 'short' })}{f.venue ? ` · ${f.venue}` : ''}
                  {f.ownListingCount ? ` · ${f.ownListingCount} listing${f.ownListingCount === 1 ? '' : 's'}` : ''}
                  {f.valueAtRisk ? ` · $${Math.round(f.valueAtRisk).toLocaleString()} at risk` : ''}
                </div>
                {f.reasons?.length > 0 && (
                  <div className="attention-reasons">{f.reasons.slice(0, 3).join(' · ')}</div>
                )}
              </div>
              <div className="attention-actions">
                {f.suggestionCount > 0 && <span className="attention-badge">{f.suggestionCount} suggestion{f.suggestionCount === 1 ? '' : 's'}</span>}
                {f.analyzedAt && <span className="attention-badge" style={{ color: 'var(--color-text-light)' }}>{timeAgo(f.analyzedAt)}</span>}
                <button className="btn-primary btn-sm" onClick={() => openCompare(f)}>Open</button>
              </div>
            </div>
          ))}
          {data.flags.length > 10 && (
            <div className="attention-row" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
              <button className="btn-secondary btn-sm" onClick={() => setShowAll(s => !s)}>
                {showAll ? 'Show top 10' : `Show all ${data.flags.length}`}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AttentionPanel;
